import { IOfferedShipmentOfferTypeEnum, Maybe } from 'types/FMSGraphqlTypes'

export const getOfferTypeLabel = (offerType: Maybe<IOfferedShipmentOfferTypeEnum>) => {
  if (!offerType) {
    return ''
  }
  switch (offerType) {
    case IOfferedShipmentOfferTypeEnum.BidAccepted:
      return 'Bid Accepted'
    case IOfferedShipmentOfferTypeEnum.WaterfallOffered:
      return 'Dedicated Rate'
    case IOfferedShipmentOfferTypeEnum.ManualOffer:
    default:
      return 'Transfix Offer'
  }
}
